var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabAgentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.864,
    height: 24.006,
    viewBox: "0 0 24.864 24.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2771",
    "data-name": "Group 2771",
    transform: "translate(-3492.686 -817.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M3506.383,829.987v-7.309h-4.409v7.773",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 2.531,
    height: 0.696,
    transform: "translate(3502.961 823.606)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 2.531,
    height: 0.696,
    transform: "translate(3502.961 825.114)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 2.531,
    height: 0.696,
    transform: "translate(3502.961 826.622)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 2.531,
    height: 0.696,
    transform: "translate(3502.961 828.13)",
    fill: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M3496.841,834.105l-3.694-4.649,3.458-2.734,3.484,4.483",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 2.421,
    height: 0.696,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3496.827, 828.617)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 2.421,
    height: 0.696,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3497.762, 829.8)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    width: 2.421,
    height: 0.696,
    transform: "matrix(-0.784, 0.62, -0.62, -0.784, 3498.698, 830.983)",
    fill: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M3513.4,834.105l3.694-4.649-3.458-2.734-3.485,4.483",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 2.421,
    height: 0.696,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3513.841, 828.071)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 2.421,
    height: 0.696,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3512.906, 829.254)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1029",
    "data-name": "Rectangle 1029",
    width: 2.421,
    height: 0.696,
    transform: "matrix(0.784, 0.62, -0.62, 0.784, 3511.97, 830.437)",
    fill: ""
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M3508.706,830.509V817.733H3504.3v5",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 2.094,
    height: 0.696,
    transform: "translate(3505.454 818.661)",
    fill: ""
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 2.094,
    height: 0.696,
    transform: "translate(3505.454 820.17)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M3498.729,832.168l1.128.661-.58,2.784,3.017,1.509-.464,2.436-3.481.232-1.74,1.276-2.088-.348a10.791,10.791,0,0,1,21.3-2.43l-1.582,1.85-1.508.58-3.132-.58-.116-2.784-1.8-2.147.058-1.914,1.857-1.16,2.607.29",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M3502.109,833.831l1.45,2.615,2.215-.7v-3.032l-2.088.232-.694-.987Z",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M3499.641,823.7h-2.8v-2.8",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1319",
    "data-name": "Line 1319",
    y1: 3.742,
    x2: 3.562,
    transform: "translate(3496.837 819.958)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M3510.6,823.7h2.8v-2.8",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1320",
    "data-name": "Line 1320",
    x1: 3.562,
    y1: 3.742,
    transform: "translate(3509.837 819.958)",
    fill: "none",
    stroke: "",
    strokeMiterlimit: 10,
    strokeWidth: 0.655
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabAgentIcon);
export default __webpack_public_path__ + "static/media/tab-agent-icon.601e84f9d9055d43f227c5c1e7914137.svg";
export { ForwardRef as ReactComponent };